import React from 'react'
import styled from '@emotion/styled'

const Container = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  background-color: #fbfbfd;
`

type Props = {
  children?: any
}

const AppContainer = ({ children }: Props) => <Container>{children}</Container>

export default AppContainer
